<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    preserveAspectRatio="xMidYMid meet"
    viewBox="264.89041095890417 255.64383561643825 125.91780821917774 150.5753424657533"
    width="121.92"
    height="146.58"
  >
    <defs>
      <path
        d="M326.85 366.58L265.89 403.22L265.89 329.93L265.89 256.64L326.85 293.28L387.81 329.93L326.85 366.58Z"
        id="c6Pryl3dB"
      ></path>
      <path
        d="M280.75 325.14L338.29 325.14L338.29 334.73L280.75 334.73L280.75 325.14Z"
        id="brbLq9ij4"
      ></path>
      <path
        d="M314.32 301.16L314.32 358.7L304.73 358.7L304.73 301.16L314.32 301.16Z"
        id="d5VcFVn0Gh"
      ></path>
    </defs>
    <g>
      <g>
        <use xlink:href="#c6Pryl3dB" opacity="1" fill-opacity="1"></use>
      </g>
      <g>
        <use
          xlink:href="#brbLq9ij4"
          opacity="1"
          fill="#000000"
          fill-opacity="1"
        ></use>
      </g>
      <g>
        <use
          xlink:href="#d5VcFVn0Gh"
          opacity="1"
          fill="#000000"
          fill-opacity="1"
        ></use>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'SvgRightPlus',
}
</script>
